/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from native/schemas/document/PageImageSource.yaml
/** @hidden */
export const PageImageSourceValues = [
    'UNDEFINED',
    'MANUAL_SNAP',
    'AUTO_SNAP',
    'CAMERA_FRAME',
    'IMPORTED',
];
//# sourceMappingURL=PageImageSource.js.map